import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl } from '../../lib/ep.js';

import { SecondaryButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection';
import SaveFeedback from '../builder/SaveFeedback.js';
import Tooltip from '../builder/Tooltip.js';

import RibbonCollection from '../ui_items/RibbonCollection.js';
import TestPromoButton from './elements/TestPromoButton';
import TemplateSaveWarning from '../utils/TemplateSaveWarning.js';

const BuilderHeader = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const promo_type = props?.promoType ?? false;

	const [ current_active, setCurrentActive ] = useState(props.current_active);
	const [ promotion, setPromotion ] = useState(props.pm.attributes);

	useEffect(() => {
		setPromotion(props.pm.attributes);
	}, [ props.pm ]);

	useEffect(() => {
		setTimeout(() => {
			window.builder_loaded = true;
		}, 100);
	}, []);

	const strip = (html) => {
		var doc = new DOMParser().parseFromString(html, 'text/html');
		return doc.body.textContent || "";
	};

	const changeTest = (test) => {
		setPromotion({ ...promotion, ['test']:test });
		setCurrentActive(0);
	};

	const title = strip((promotion.title) ? promotion.title : `${i18n("Promotion")} #${promotion.id}`);
	const draft_promotion = (promotion.status != undefined && promotion.status == '0') ? true : false;
	const active_promotion = (promotion.status != undefined && promotion.status == '1') ? true : false;

	const is_onair = (promotion.promotion_type_id == '42') ? true : false;

	const promo_type_icon = promo_type?.icon_class ?? false;

	let promo_version_label = '';
	switch(promotion.promo_type) {
		case '0':
			promo_version_label = "Basic";
			break;

		case '1':
			promo_version_label = "Premium";
			break;

		case '2':
			promo_version_label = "White Label";
			break;
	}

	let ribbons = [];
	if(draft_promotion) {
		ribbons.push({
			title:i18n("Draft"),
			autotranslate:false,
			color:'orange',
			is_light:false,
		});
	} else if(active_promotion) {
		if(EPDateBefore(promotion.end_date)) {
			ribbons.push({
				title:i18n("Expired"),
				autotranslate:false,
				color:'red',
				is_light:false,
			});
		} else {
			ribbons.push({
				title:i18n("***Active"),
				autotranslate:false,
				color:'green',
				is_light:false,
			});
		}
	}
	ribbons.push({
		title:<>{i18n("Version")}: <strong>{i18n(promo_version_label)}</strong></>,
		autotranslate:false,
		color:'gray',
		is_light:true,
		is_html:true,
	});
	ribbons.push({
		title:<>{i18n("ID")}: <strong>#{promotion.id}</strong></>,
		autotranslate:false,
		color:'gray',
		is_light:true,
		is_copy:true,
		copy:promotion.id,
		tooltip_position:'right',
		is_html:true,
	});

	const domain = props?.pm?.Accountdomain ?? undefined;
	const protocol = `${window.location.href.split("/")[0]}//`;
	const main_promo_link = `${(domain && !draft_promotion) ? `${protocol}${domain.domain}/` : window.public_url}p/${promotion.id}`;

	return (
		<header class="builder_header">
			<div style={{flexGrow:'1'}}>
				<div class={`promo_title${(promo_type_icon !== false) ? ` with_icon` : ''}`}>
					{(promo_type_icon !== false) && (
						<span class={`icon ${promo_type_icon}`}>
							<Tooltip
								with_icon={false}
								position='right'
							>{promo_type.name}</Tooltip>
						</span>
					)}

					<RibbonCollection
						items={ribbons}
					/>

					<div class="title">
						<h1 class="whiteColor gui_cutTextOnOverflow" dangerouslySetInnerHTML={{ __html:title}} />
					</div>
				</div>
			</div>

			<div class="sided_ctas">
				<ButtonCollection _class={{other:'gui_only_wide_screen'}}>
					{(!is_onair && draft_promotion) && (
						<TestPromoButton
							promotion={promotion}
							onChangeTest={(test) => changeTest(test)}
							intl={props.intl}
							current_active={current_active}
							is_builder={true}
						/>
					)}

					{(!is_onair && active_promotion) && (
						<SecondaryButton
							_href={getRemotedbUrl(`${main_promo_link}`, null, false)}
							_target='_blank'
							icon='knk-visible'
						>Go to promotion</SecondaryButton>
					)}

					<SecondaryButton
						_href={getRemotedbUrl(`/promotions/profile/${promotion.id}/`)}
						icon='knk-logout'
						_class={{ other:'exit_builder_button' }}
					>Exit editor</SecondaryButton>
				</ButtonCollection>

				<ButtonCollection _class={{other:'gui_only_thin_screen'}}>
					{(!is_onair && draft_promotion) && (
						<TestPromoButton
							promotion={promotion}
							onChangeTest={(test) => changeTest(test)}
							intl={props.intl}
							current_active={current_active}
							is_builder={true}
							is_mobile_version={true}
						/>
					)}

					{(!is_onair && active_promotion) && (
						<SecondaryButton
							squared={true}
							_href={getRemotedbUrl(`${main_promo_link}`, null, false)}
							_target='_blank'
							color={false}
							icon='knk-visible blueButton'
						/>
					)}

					<SecondaryButton
						squared={true}
						_href={getRemotedbUrl(`/promotions/profile/${promotion.id}/`)}
						icon='knk-logout blueButton'
						color={false}
						_class={{ other:'exit_builder_button' }}
					/>
				</ButtonCollection>
			</div>

			<TemplateSaveWarning
				pm={props.pm}
				intl={props.intl}
				ref={(e) => {
					window.template_warning = e;
				}}
			/>

			<SaveFeedback />
		</header>
	)
};

export default injectIntl(BuilderHeader);